import { Menu, MenuItem } from "@mui/material";
import { Pid } from "@shared/types/domain";
import { ConditionalMenuItem } from "./ConditionalMenuItem";

interface PidContextMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  pid: Pid | undefined;
  isAdmin: boolean;
  onClose: () => void;
  onDownload: () => void;
  onReprocess: () => void;
  onRename: () => void;
  onDelete: () => void;
}

export default function PidContextMenu({
  anchorEl,
  open,
  pid,
  isAdmin,
  onClose,
  onDownload,
  onReprocess,
  onRename,
  onDelete,
}: PidContextMenuProps) {
  const canReprocess =
    pid?.status === "error" || pid?.status === "required_spof_review";

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      slotProps={{ paper: { sx: { minWidth: 200 } } }}
    >
      <MenuItem
        dense
        sx={{ fontSize: "0.82rem" }}
        onClick={() => {
          onDownload();
          onClose();
        }}
      >
        Download Original Pdf
      </MenuItem>

      <ConditionalMenuItem
        disabled={!isAdmin || !canReprocess}
        disabledTitle={
          !isAdmin
            ? "Admin only"
            : "Only available for PIDs in error or required SPOF review status"
        }
        onClick={() => {
          onReprocess();
          onClose();
        }}
      >
        Reprocess
      </ConditionalMenuItem>

      <ConditionalMenuItem
        disabled={!isAdmin}
        disabledTitle="Admin only"
        onClick={() => {
          onRename();
          onClose();
        }}
      >
        Rename
      </ConditionalMenuItem>

      <ConditionalMenuItem
        disabled={!isAdmin}
        disabledTitle="Admin only"
        color="#E30613"
        onClick={() => {
          onDelete();
          onClose();
        }}
      >
        Delete
      </ConditionalMenuItem>
    </Menu>
  );
}
